import { ShrinkOutlined, ArrowsAltOutlined, DownOutlined, SwapOutlined } from '@ant-design/icons';
import { useContext, useState } from 'react';
import { Dropdown, Menu, Space } from 'antd';
import { css } from '@emotion/css';
import { OperateValueContext } from './context';
import { useTranslate } from '@tolgee/react';

/**
 * 排序和展开操作
 * @constructor
 */
const Operate = () => {
  const { foldState, setFoldState, sortBy, setSortBy } = useContext(OperateValueContext);
  const { t } = useTranslate();
  const [visible, setVisible] = useState(false);

  return (
    <div className="flex items-center text-[#515359] hover:text-[#3366ff]">
      {foldState === 'unfold' ? (
        <div className="cursor-pointer" onClick={() => setFoldState('fold')}>
          <ShrinkOutlined className="mr-[4px]" />
          {t('single_fold_sku')}
        </div>
      ) : (
        <div className="cursor-pointer" onClick={() => setFoldState('unfold')}>
          <ArrowsAltOutlined className="mr-[4px]" />
          {t('single_unfold_sku')}
        </div>
      )}

      <Dropdown
        className="ml-[8px] cursor-pointer"
        trigger={['click']}
        visible={visible}
        onVisibleChange={setVisible}
        overlay={
          <Menu
            onClick={(e) => {
              setSortBy(e.key as any);
              setVisible(false);
            }}
            selectedKeys={[sortBy]}
          >
            <Menu.Item key={'1'}>{t('single_sort_by_sales')}</Menu.Item>
            <Menu.Item key={'2'}>{t('single_sort_by_time')}</Menu.Item>
          </Menu>
        }
      >
        <div>
          <SwapOutlined
            className={css`
              transform: rotate(90deg);
              margin-right: 4px;
            `}
          />
          <Space>
            {sortBy === '1' ? t('single_sort_by_sales') : t('single_sort_by_time')}
            <DownOutlined />
          </Space>
        </div>
      </Dropdown>
    </div>
  );
};

export default Operate;
